<template>
  <v-container>
    <v-layout>
      <v-flex md12>
        <v-toolbar color="teal" dark>
          <v-toolbar-title>Export Lab Sample Data</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 sm6>
            <v-select label="Select Station Media" :items="medias" v-model="selectedMedias" multiple chips hint="What are the station media" persistent-hint></v-select>
          </v-flex>

          <v-flex xs12 sm12>
            <v-data-table v-model="selected" :headers="headers" :items="stationsForSelect" select-all :pagination.sync="pagination" item-key="name" class="elevation-1">
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox primary hide-details @click.native="toggleAll" :input-value="props.all" :indeterminate="props.indeterminate"></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="changeSort(header.value)">
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr :active="props.selected" @click="props.selected = !props.selected">
                  <td>
                    <v-checkbox primary hide-details :input-value="props.selected"></v-checkbox>
                  </td>
                  <td class="text-xs-right">{{ props.item.media }}</td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                </tr>
              </template>
            </v-data-table>

          </v-flex>

        </v-card-text>
        <v-card-actions>
          <v-btn color="orange" @click="downloadGroundWaterReport">{{ $t('Button.Download') }}</v-btn>
        </v-card-actions>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  const { mapGetters } = createNamespacedHelpers('stations')

  export default {
    mixins: [],
    props: [],
    mounted() {
      this.stationsForSelect = this.getStationsForSelect()
    },
    data() {
      return {
        selected: [],
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10,
        },
        selectedMedias: [],
        stationsForSelect: [],
        headers: [{
          text: 'Media',
          value: 'media',
        },
        {
          text: 'Station Name',
          value: 'name',
        },
        ],
      }
    },
    computed: {
      ...mapGetters({
        //distinctStations: 'distinctStations',
        distinctMedias: 'distinctMedias',
      }),
      medias() {
        return this.distinctMedias.map(x => x.name)
      },
    },
    watch: {
      selectedMedias() {
        console.log(this.selectedMedias)
        this.stationsForSelect = this.getStationsForSelect()
      },
    },
    methods: {
      toggleAll() {
        if (this.selected.length) this.selected = []
        else this.selected = this.stationsForSelect.slice()
      },
      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getStationsForSelect() {
        var sm = this.medias
        if (this.selectedMedias.length > 0) {
          sm = this.selectedMedias
        }
        if (this.distinctMedias == null) {
          return []
        }
        var matchedMedia = this.distinctMedias.filter(x => sm.indexOf(x.name) >= 0)
        var stations = matchedMedia.map(
          m => m.items.map(
            t => {
              return {
                meida: m.name,
                name: t.name,
                value: false,
              }
            })
        )
        var merged = [].concat.apply([], stations)
        return merged
      },
      downloadGroundWaterReport() {
        var url = '/WaterQualityReport/DownloadGroundWaterStation'
        const elink = document.createElement('a')
        elink.style.display = 'none'
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      },
    },
  }
</script>